/**
 * Video Sound Toggle
 * Handles mute/unmute functionality for video elements with sound toggle buttons
 * Uses event delegation to handle dynamically added videos
 * Automatically mutes hidden videos to prevent audio conflicts
 */

/**
 * Mute videos that are hidden by CSS (display: none or hidden class)
 */
function muteHiddenVideos() {
  const allVideos = document.querySelectorAll('[data-video-element][data-video-id]')
  allVideos.forEach((video) => {
    const isHidden = window.getComputedStyle(video).display === 'none' ||
                     video.offsetParent === null

    if (isHidden && !video.muted) {
      video.muted = true
      const videoId = video.getAttribute('data-video-id')
      const button = document.querySelector(`[data-video-sound-toggle][data-video-id="${videoId}"]`)
      if (button) {
        const soundOffIcon = button.querySelector('.sound-off-icon')
        const soundOnIcon = button.querySelector('.sound-on-icon')
        const muteText = button.querySelector('.mute-text')

        if (soundOffIcon) soundOffIcon.classList.remove('hidden')
        if (soundOnIcon) soundOnIcon.classList.add('hidden')
        button.setAttribute('aria-label', 'Unmute video')
        if (muteText) muteText.textContent = 'Unmute'
      }
    }
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', muteHiddenVideos)
} else {
  muteHiddenVideos()
}

let resizeTimer
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer)
  resizeTimer = setTimeout(muteHiddenVideos, 250)
})

document.addEventListener('click', (e) => {
  const toggleButton = e.target.closest('[data-video-sound-toggle]')
  if (!toggleButton) return

  e.preventDefault()
  e.stopPropagation()

  const videoId = toggleButton.getAttribute('data-video-id')
  const video = videoId ? document.querySelector(`[data-video-element][data-video-id="${videoId}"]`) : null
  const soundOffIcon = toggleButton.querySelector('.sound-off-icon')
  const soundOnIcon = toggleButton.querySelector('.sound-on-icon')
  const muteText = toggleButton.querySelector('.mute-text')

  if (!video || !soundOffIcon || !soundOnIcon) return
  if (video.muted) {
    video.muted = false
  } else {
    video.muted = true
  }

  if (video.paused) {
    video.play()
  }

  if (video.muted) {
    soundOffIcon.classList.remove('hidden')
    soundOnIcon.classList.add('hidden')
    toggleButton.setAttribute('aria-label', 'Unmute video')
    if (muteText) muteText.textContent = 'Unmute'
  } else {
    soundOffIcon.classList.add('hidden')
    soundOnIcon.classList.remove('hidden')
    toggleButton.setAttribute('aria-label', 'Mute video')
    if (muteText) muteText.textContent = 'Mute'
  }
})
